import { render, staticRenderFns } from "./RaterDataCollectionTable.vue?vue&type=template&id=1f5fccf0&"
import script from "./RaterDataCollectionTable.vue?vue&type=script&lang=js&"
export * from "./RaterDataCollectionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports